import React, { useCallback, useState } from 'react';
import { Typo, Page, ListTable, IconAsButton } from '../../ui';
import { API_STATUS } from '../../utils/constants';
import { useIsIncarnated, useRefetchOnAuthChange } from '../auth/hooks';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../ui/Page/PageHeader';
import PageControls from '../../ui/Page/PageControls';
import { useTransactions, useTransactionsActions } from './hooks';
import PageSection from '../../ui/Page/PageSection';

const Transactions = () => {
  const { t } = useTranslation();
  const isIncarnated = useIsIncarnated();
  const [searchQuery, setSearchQuery] = useState('');
  const [savedCurrentPage, setSavedCurrentPage] = useState(0);

  const {
    transactions = [],
    isLoading,
    refetch,
  } = useTransactions(undefined, {
    skip: !isIncarnated,
  });
  useRefetchOnAuthChange(refetch);
  const { resendReceipt } = useTransactionsActions();

  const resend = useCallback(
    async (id) => {
      await resendReceipt(id);
    },
    [resendReceipt],
  );

  const [tableInfo, setTableInfo] = useState([
    { label: t('transactions.buyerName'), hasSorting: { sortedMethod: 'string', propVal: 'buyer' }, data: (item) => item.buyer },
    { label: t('globals.course'), hasSorting: { sortedMethod: 'string', propVal: 'caption' }, data: (item) => item.caption },
    { label: t('transactions.amount'), data: (item) => `${item.amount} ${item.currency}` },
    { label: t('globals.date'), hasSorting: { sortedMethod: 'date', propVal: 'date' }, data: (item) => item.date && item.date.split(' ')[0] },
    // { label: 'where' },
    {
      label: t('globals.status'),
      hasSorting: { sortedMethod: 'number', propVal: 'status' },
      data: (item) =>
        item.status === API_STATUS.STATUS_REFUND
          ? t('transactions.refunded')
          : item.status === API_STATUS.STATUS_PAID || API_STATUS.STATUS_GOOD
          ? t('transactions.paid')
          : item.status === API_STATUS.STATUS_ERROR
          ? t('globals.error')
          : '-',
    },
    {
      label: t('transactions.resendReceipt'),
      data: (item) => <IconAsButton iconName='Receipt' tooltipLabel={t('transactions.resendReceipt')} clickHandle={() => resend(item.id)} />,
    },
  ]);

  const handleSearch = useCallback((value) => {
    setSearchQuery(value);
  }, []);

  const clearSearch = useCallback(() => {
    setSearchQuery('');
  }, []);

  return (
    <Page
      staticElements={
        <PageHeader>
          <PageControls onClearSearch={clearSearch} onSearch={handleSearch} placeholder={t('transactions.search')} disableClear={!searchQuery} />
        </PageHeader>
      }
    >
      <PageSection>
        {isLoading ? (
          <Typo.TextTitle>{t('globals.loading')}</Typo.TextTitle>
        ) : transactions.length ? (
          <ListTable
            tableInfo={tableInfo}
            data={searchQuery ? transactions.filter((el) => el.buyer.toLowerCase().includes(searchQuery.toLowerCase())) : transactions}
            tableName={'transactions'}
            tableSetter={setTableInfo}
            keepTrackOfPage={setSavedCurrentPage}
            defaultStartPage={savedCurrentPage}
          />
        ) : (
          <Typo.TextTitle>{t('transactions.noTransactions')}</Typo.TextTitle>
        )}
      </PageSection>
    </Page>
  );
};

export default Transactions;
